// assets/cart.api.js
window.CartMethodsApi = {
    updateCart() {
        let resultData = this.getPrepareData();
        let apiBaseUrl = window.PXUTheme.theme_settings.api_beckend_url;
        let endpoint = 'api/shopify/variantsupdate';

        if (Object.keys(this.prepareData).length !== 0) {
            // cart_token lets the backend read this cart's real quantities and lines
            let cartToken = (this.storageCart && this.storageCart.token) || '';
            return axios.post(apiBaseUrl + endpoint, { data: this.prepareData, cart_token: cartToken })
                .then(cartResponse => {
                    let feeSwaps = cartResponse && cartResponse.data ? cartResponse.data.fee_swaps : null;
                    return this.applyFeeSwaps(feeSwaps);
                })
                .then(() => {
                    this.disableCheckout = false;
                    localStorage.removeItem('priceChange');
                })
                .catch(error => {
                    console.error('updateCart failed', error);
                    // Re-throw so the caller (checkout intercept) can handle it
                    throw error;
                });
        }

        // Nothing to update — resolve immediately
        return Promise.resolve();
    },

    /**
     * Pooled fee variants are shared between carts and never repriced. When a group's fee
     * total changes, variantsupdate returns fee_swaps {groupID: {fee_variant_id, ...}}:
     * add the new fee variant with the line's properties, then remove the old fee line by
     * its key. Add first, so a failure never leaves the group without a fee line. A 422
     * "Cannot find variant" for the new fee variant is touched and retried once; any other
     * failure rejects and blocks the checkout redirect.
     */
    applyFeeSwaps(feeSwaps) {
        const groupIds = feeSwaps ? Object.keys(feeSwaps) : [];
        if (!groupIds.length) return Promise.resolve();

        const root = window.Shopify.routes.root;
        let chain = Promise.resolve();

        groupIds.forEach(groupID => {
            const swap = feeSwaps[groupID];
            chain = chain.then(() => {
                const items = (this.storageCart && this.storageCart.items) || [];
                const feeLine = items.find(i =>
                    i && i.properties && i.properties._groupID == groupID && (i.title || '').includes('Associated'));
                if (!feeLine || !swap || !swap.fee_variant_id || feeLine.variant_id == swap.fee_variant_id) {
                    return null;
                }

                const properties = Object.assign({}, feeLine.properties);
                // The old signature binds the group to the old variant; the server sends a new one
                if (swap.fee_sig) {
                    properties._fee_sig = swap.fee_sig;
                } else {
                    delete properties._fee_sig;
                }
                const addFeeLine = () => axios.post(root + 'cart/add.js', {
                        items: [{ id: swap.fee_variant_id, quantity: 1, properties: properties }]
                    });

                return addFeeLine()
                    .catch(error => {
                        // A fresh pool variant can be cached as "not found" by the cart; a touch
                        // (real write on the backend) clears it, then retry once.
                        if (!this.isVariantNotFound(error)) throw error;
                        return this.touchVariants([swap.fee_variant_id])
                            .then(() => new Promise(resolve => setTimeout(resolve, 2000)))
                            .then(addFeeLine);
                    })
                    .then(() => axios.post(root + 'cart/change.js', { id: feeLine.key, quantity: 0 }))
                    .then(response => {
                        this.updateModuleState(response.data);
                        this.sortCartItems();
                    });
            });
        });

        return chain;
    },

    isVariantNotFound(error) {
        return !!(error && error.response && error.response.status === 422
            && error.response.data && error.response.data.description === 'Cannot find variant');
    },

    /**
     * Ask the backend to touch variants the cart could not find (api/shopify/variants/touch:
     * price +0.01 and back). Never rejects; resolves with the number of touched variants.
     */
    touchVariants(variantIds) {
        const settings = (window.PXUTheme && window.PXUTheme.theme_settings) || {};
        const shopDomain = settings.api_shop_domain || '';
        if (!settings.api_beckend_url || !shopDomain) return Promise.resolve(0);

        return axios.post(settings.api_beckend_url + 'api/shopify/variants/touch', {
                shop: shopDomain.replace('.myshopify.com', ''),
                shop_domain: shopDomain,
                variant_ids: variantIds
            })
            .then(response => (response && response.data && response.data.touched) || 0)
            .catch(() => 0);
    },

    updateCartCount(cart) {
        if (!cart || cart.item_count === undefined) return;
        // Subtract Associated Fee items from total count
        const assocFeeCount = Array.isArray(cart.items)
            ? cart.items.filter(item => item.title && item.title.includes('Associated Fee')).length
            : 0;
        const count = Math.max(0, cart.item_count - assocFeeCount);
        document.querySelectorAll('.cart_count').forEach(el => el.textContent = count);
    },

    removeCartLine(updatesData, index = false, cartItem = false) {
        if(Object.keys(updatesData).length) {
            $('#page-loader').css({'display': 'block'});
            let result = jQuery.ajax({
                url: window.Shopify.routes.root + 'cart/update.js',
                method: 'POST',
                dataType: 'json',
                // JSON body: a missing line key returns 422 instead of falling back to variant_id
                contentType: 'application/json',
                data: JSON.stringify({ updates: updatesData })
            }).done( cartData => {
                this.updateModuleState(cartData);
                this.sortCartItems();
                this.removeAssocProd();
                if (window.__cartRecovery) window.__cartRecovery.recoverCart();
                // For calendar bundles: removing one item changes total qty,
                // which may shift the price tier for all remaining calendar items.
                if (cartItem && this.isCalendarProduct(cartItem.properties)) {
                    this.cartItems.forEach((item, itemIndex) => {
                        if (item && item.product_title != "Associated Fee" && this.isCalendarProduct(item.properties)) {
                            this.changePrice(item, itemIndex);
                        }
                    });
                    this.updateModuleState(this.storageCart);
                    this.sortCartItems();
                }

                // For regular products with multiple color variants: removing one variant
                // changes total qty per group, which may shift the price tier for remaining
                // variants. Recalculate price for all remaining items in the same group,
                // then apply via updateModuleState so price + linePriceProperty stay correct.
                if (index !== false && cartItem && !this.isCalendarProduct(cartItem.properties)) {
                    const groupID = cartItem.properties._groupID;
                    this.cartItems.forEach((item, itemIndex) => {
                        if (item && item.product_title != "Associated Fee" && item.properties._groupID == groupID) {
                            this.changePrice(item, itemIndex);
                        }
                    });
                    this.updateModuleState(this.storageCart);
                    this.sortCartItems();
                }

                // Recalculate dynamic fees (Running Fee, Additional Location Fee).
                // Must run after price recalculation so minProductQty / totalQty is current.
                this.recalculateDynamicFees();

                /*For not associated fee cart item*/
                if (index !== false) {
                    let storageCart = JSON.parse(localStorage.cartItems);
                    // index is the removed line's old position, stale after removal — validate
                    // the group whose qty dropped, if it still has products
                    const groupIdx = this.cartItems.findIndex(i =>
                        i && i.properties._groupID == cartItem.properties._groupID && !(i.title || '').includes('Associated'));
                    if (groupIdx !== -1) {
                        this.validateMinQty(groupIdx);
                    }
                    storageCart.items = this.cartItems;
                    let removeMinQtyAndPriceChange = this.removeMinQtyAndPriceChange(cartItem.properties._groupID);
                    if (removeMinQtyAndPriceChange) {
                        this.removePriceChangeFromStorage(cartItem.properties._groupID);
                        this.removeMinQty(cartItem.properties._groupID);
                    }
                    this.updateCartCount(storageCart);
                }
            }).fail(() => {
                console.error("removing error");
                this.updateCartItemsFromCartJson();
            }).always(() => {
                // Here, not in done(): an exception there must not leave the cart stuck pending
                $('#page-loader').css({'display': 'none'});
                this.qtyPending = false;
                console.log("finished");
            });
        }
    },

    changeCartLine(cartItem) {
        let updatesData = {}
        updatesData['id'] = cartItem.key;
        updatesData['quantity'] = cartItem.quantity;
        updatesData['properties'] = cartItem.properties;

        axios.post(window.Shopify.routes.root + 'cart/change.js', updatesData)
            .then(cartResponse => {
                console.warn("changeCartLine");
                console.log(cartResponse);

                // updateModuleState handles everything:
                // 1. applies priceChange → restores tier price + linePriceProperty for product items
                // 2. mergeAssocFeeLinePrices → restores fee items from in-memory
                // 3. storageCart + cartItems + localStorage
                this.updateModuleState(cartResponse.data);

                this.calculateFee();
                this.sortCartItems();
            })
            .catch(error => {
                console.error("changeCartLine error");
                console.error(error);
            });
        console.log("this.changeDataCar");
    },

    updateCartItemsFromCartJson() {
        let result = jQuery.ajax({
            url: window.location.origin + '/cart.json',
            method: 'GET',
            dataType: 'json'
        }).done( cartResponse => {
            this.storageCart = cartResponse;
            this.cartItems = this.storageCart.items;
            this.sortCartItems();
            // created() runs calculateFee() before this async response arrives
            this.calculateFee();
            // Later handlers read localStorage.cartItems directly
            try {
                this.updateLocalStorage(cartResponse);
            } catch (e) {
                console.error('localStorage write failed', e);
            }
        }).fail(() => {
            console.error("fail getting cart.json");
        });
    },

    updateCartInit() {
        jQuery.ajax({
            url: window.Shopify.routes.root + 'cart/update.js',
            method: 'POST',
            dataType: 'json',
            data: { updates: {} }
        }).done(cartData => {
            this.updateModuleState(cartData);
            this.sortCartItems();
        });
    },
};
